module.exports = __webpack_public_path__ + "static/media/logo.76e1e2b9.svg";